import bgg from 'url:../../assets/wtrok/fm/Background 064.png';
import bgs from 'url:../../assets/wtrok/fm/Background 544.png';
import amgoth from 'url:../../assets/wtrok/fm/American Gothic.png';
import t198 from 'url:../../assets/wtrok/fm/Telephone 098.png';
import cdrom from 'url:../../assets/wtrok/fm/CD ROM.png';
import rec from 'url:../../assets/wtrok/fm/Records 2.png';
import moonr from 'url:../../assets/wtrok/fm/Moon Reading.png';
import gold from 'url:../../assets/wtrok/fm/Gold Teeth.png';
import sat4 from 'url:../../assets/wtrok/fm/Satellite - Cartoon 4.png';
import footguy from 'url:../../assets/wtrok/fm/Foot Guy.png';
import radst from 'url:../../assets/wtrok/fm/Radio Station.png';
import adance from 'url:../../assets/wtrok/fm/Space Aliens Dancing 2.png';
import satd from 'url:../../assets/wtrok/fm/Satellite Dish 27.png';
import carmus from 'url:../../assets/wtrok/fm/ltm11.png';
import greenc from 'url:../../assets/wtrok/fm/Green Cone - Purple Lips.png';
import merid from 'url:../../assets/wtrok/fm/Meridian M2008.png';
import hitg from 'url:../../assets/wtrok/fm/Head in the Ground.png';
import mailb from 'url:../../assets/wtrok/fm/Mail Bag 2.png';
import stopw from 'url:../../assets/wtrok/fm/Stop Watch - Cartoon.png';
import newsr from 'url:../../assets/wtrok/fm/News Reporter.png';
import duckm from 'url:../../assets/wtrok/fm/Listening to Music 07.png';
import micy from 'url:../../assets/wtrok/fm/Microphone - Yelling.png';
import telec from 'url:../../assets/wtrok/fm/Telephone - Cartoon.png';
import sackr from 'url:../../assets/wtrok/fm/Sack Race - Bear.png';
import sing15 from 'url:../../assets/wtrok/fm/Singer 15.png';
import fraidy from 'url:../../assets/wtrok/fm/Fraidycat Watching.png';
import accord from 'url:../../assets/wtrok/fm/Accordion - Happy.png';
import clownc from 'url:../../assets/wtrok/fm/Clown in Car 4.png';
import mobile from 'url:../../assets/wtrok/fm/Mobile Phone 2.png';
import piggy from 'url:../../assets/wtrok/fm/Piggy Bank & Coins.png';
import longneck from 'url:../../assets/wtrok/fm/Longneck Creature.png';
import topsec from 'url:../../assets/wtrok/fm/Weapon - Top Secret.png';
import horser from 'url:../../assets/wtrok/fm/Horse Racing 19.png';
import drumf from 'url:../../assets/wtrok/fm/Drummer - Frog.png';
import tambf from 'url:../../assets/wtrok/fm/Tambourine Player - Frog.png';
import guitf from 'url:../../assets/wtrok/fm/Guitarist - Frog.png';
import mic12 from 'url:../../assets/wtrok/fm/Microphone 12.png';
import greenie from 'url:../../assets/wtrok/fm/Greenie.png';
import beeper from 'url:../../assets/wtrok/fm/Beeper 7.png';
import snoop from 'url:../../assets/wtrok/fm/Super Snooper.png';
import sing57 from 'url:../../assets/wtrok/fm/Singer 57.png';
import speakr from 'url:../../assets/wtrok/fm/Speaker - Blasting.png';
import clwnbg from 'url:../../assets/wtrok/fm/Clown Background.png';
import dj5 from 'url:../../assets/wtrok/fm/Disc Jockey 5.png';
import crys from 'url:../../assets/wtrok/fm/Crystal Ball - Evil.png';
import cbrad from 'url:../../assets/wtrok/fm/CB Radio 2.png';
import sing61 from 'url:../../assets/wtrok/fm/Singer 61.png';
import eggg from 'url:../../assets/wtrok/fm/Guitarist - Egg.png';
import dj4 from 'url:../../assets/wtrok/fm/Disc Jockey 4.png';
import volume from 'url:../../assets/wtrok/fm/Volume.png';
import beep from 'url:../../assets/wtrok/sfx/beep.mp3';
import banjo from 'url:../../assets/wtrok/sfx/banjo.mp3';
import fart from 'url:../../assets/fart.mp3';

const STD_WIDTH : number = 1920;
const STD_HEIGHT : number = 1080;

export function WTROKFM () {
    const width = 1920 / 2;
    return <div className="page-basic bg-black v-box">
        <div className='height-64' />
        <div className="pos-rel mask-content" style={{width, height: width * STD_HEIGHT / STD_WIDTH}}>
            <FME src={bgg} left={0.00} top={0.00} width={100.00} height={100.00} />
            <FME src={bgs} left={0.00} top={0.00} width={100.00} height={46.85} />
            <FME src={cdrom} left={-4.22} top={-3.33} width={18.67} />
            <FME src={rec} left={36.61} top={2.59} width={21.19} />
            <FME src={rec} left={62.66} top={7.96} width={21.19} />
            <FME src={rec} left={88.39} top={14.72} width={21.19} />
            <FME src={moonr} left={11.46} top={-1.48} width={15.86} />
            <FME src={gold} left={74.32} top={-2.13} width={11.33} class='rotate-180' />
            <FME src={sat4} left={85.21} top={3.06} width={6.10} />
            <FME src={footguy} left={22.81} top={26.94} width={11.10} />
            <FME src={radst} left={49.69} top={27.96} width={19.57} />
            <FME src={adance} left={27.71} top={16.48} width={5.05} />
            <FME src={satd} left={93.44} top={36.57} width={5.95} />
            <FME src={amgoth} left={84.43} top={32.22} width={4.00} />
            <FME src={carmus} left={73.18} top={41.39} width={6.67} class='flip-h' />
            <FME src={greenc} left={1.56} top={25.65} width={5.33} />
            <FME src={merid} left={5.99} top={28.70} width={4.29} />
            <FME src={hitg} left={13.59} top={40.83} width={5.95} />
            <FME src={mailb} left={43.18} top={42.59} width={3.10} class='flip-h' />
            <FME src={stopw} left={50.26} top={21.76} width={11.33} class='flip-h' />
            <FME src={newsr} left={46.35} top={33.89} width={5.95} class='flip-h' />
            <FME src={duckm} left={31.98} top={37.87} width={6.52} />
            <FME src={micy} left={39.06} top={42.13} width={2.86} />
            <FME src={telec} left={64.06} top={42.78} width={6.43} />
            <FME src={sackr} left={72.86} top={46.02} width={3.67} />
            <FME src={fraidy} left={88.39} top={47.04} width={3.05} />
            <FME src={sing15} left={91.72} top={39.35} width={4.81} class='flip-h' />
            <FME src={accord} left={93.44} top={52.96} width={4.95} />
            <FME src={clownc} left={5.63} top={42.13} width={8.19} />
            <FME src={mobile} left={1.67} top={42.22} width={5.86} class='wtrok-rot-n27' />
            <FME src={piggy} left={64.01} top={53.43} width={5.76} />
            <FME src={longneck} left={51.98} top={49.44} width={6.81} />
            <FME src={topsec} left={24.90} top={49.54} width={7.29} />
            <FME src={horser} left={11.51} top={52.96} width={11.86} />
            <FME src={drumf} left={76.56} top={52.04} width={7.14} />
            <FME src={tambf} left={66.61} top={57.69} width={10.76} />
            <FME src={guitf} left={79.38} top={57.78} width={9.29} sfx={banjo} />
            <FME src={mic12} left={76.35} top={68.70} width={2.71} />
            <FME src={greenie} left={88.65} top={62.69} width={7.10} sfx={fart} />
            <FME src={beeper} left={56.77} top={60.74} width={8.10} />
            <FME src={snoop} left={42.24} top={56.48} width={9.76} />
            <FME src={sing57} left={33.59} top={56.20} width={6.48} />
            <FME src={speakr} left={20.68} top={60.74} width={10.43} />
            <FME src={clwnbg} left={2.97} top={61.57} width={4.90} />
            <FME src={dj5} left={5.73} top={66.39} width={15.24} />
            <FME src={crys} left={2.29} top={85.28} width={4.67} />
            <FME src={cbrad} left={77.55} top={85.19} width={10.19} />
            <FME src={sing61} left={87.45} top={75.00} width={8.71} />
            <FME src={eggg} left={57.86} top={68.06} width={19.57} />
            <FME src={dj4} left={46.61} top={71.11} width={11.71} />
            <FME src={t198} left={26.30} top={73.61} width={16.86} />
            <FME src={volume} left={43.02} top={90.83} width={4.19} />
        </div>
    </div>
}

function FME (props: {
    src: string,
    top: number,
    left: number,
    width: number,
    height ?: number,
    class ?: string,
    sfx ?: string
}) {
    const src = props.src;
    const t = props.top;
    const l = props.left;
    const w = props.width;
    const c = props.class !== undefined ? props.class : '';
    const a = props.sfx !== undefined ? props.sfx : beep;
    
    const audio = new Audio();
    audio.volume = 0.1;
    const playAudio = () => {
        audio.src = a;
        audio.play();
    };

    if (props.height !== undefined)
    {
        return <img src={src} onClick={playAudio} className={'pos-abs ' + c} style={{
            top: t + "%",
            left: l + "%",
            width: w + "%",
            height: props.height + "%"
        }} />
    }
    else
    {
        return <img src={src} onClick={playAudio} className={'pos-abs ' + c} style={{
            top: t + "%",
            left: l + "%",
            width: w + "%"
        }} />
    }
}